<template>
  <div>
    <el-dialog
      :title="option.title"
      :visible.sync="option.dialogVisible"
      width="80%"
      :before-close="handleClose"
      append-to-body
      top="30px"
    >
      <iframe
        style="width: 100%; height: 55vh"
        :src="option.src"
        frameborder="0"
      ></iframe>
      <span slot="footer" class="dialog-footer">
        <el-button @click="option.dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["option"],
};
</script>

<style>
</style>